<template>
  <pdf class="media-file-video preview" :style="style" :type="type"/>
</template>


<script>
import pdf from 'vue-pdf';

export default {
  name: 'K2Pdf',
  created() {
  },
  components: {
    pdf,
  },
  props: ["style","type"],
}
</script>
<style>
</style>
